import React from "react";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "../mock";
import Reveal from "./Reveal";

function initials(name) {
  return name
    .split(" ")
    .map((p) => p[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

function TestimonialCard({ t }) {
  return (
    <article className="flex-shrink-0 w-[340px] md:w-[400px] bg-white rounded-2xl border border-[#ece3cc] p-7 shadow-sm hover:shadow-lg hover:shadow-[#b59557]/10 transition-shadow duration-300 mx-3 my-1">
      <Quote className="h-7 w-7 text-[#d4b97a]" strokeWidth={1.6} />
      <p className="mt-3 text-[#3a3228] text-[15px] leading-relaxed font-serif italic">
        “{t.text}”
      </p>
      <div className="mt-5 pt-5 border-t border-[#f0e8d3] flex items-center gap-3">
        <div className="h-10 w-10 rounded-full bg-gradient-to-br from-[#d4b97a] to-[#8a7340] text-white flex items-center justify-center text-sm font-medium">
          {initials(t.name)}
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-medium text-[#1a1816] text-sm">{t.name}</div>
          <div className="flex items-center gap-0.5 mt-0.5" aria-label="5 estrellas">
            {[0, 1, 2, 3, 4].map((i) => (
              <Star key={i} className="h-3.5 w-3.5 fill-[#d4b97a] text-[#d4b97a]" />
            ))}
          </div>
        </div>
        <span className="text-[10px] tracking-[0.18em] uppercase text-[#8a7340] font-medium">
          Verificado
        </span>
      </div>
    </article>
  );
}

export default function Testimonials() {
  // Split into two rows
  const half = Math.ceil(TESTIMONIALS.length / 2);
  const row1 = TESTIMONIALS.slice(0, half);
  const row2 = TESTIMONIALS.slice(half);

  return (
    <section
      id="opiniones"
      className="py-20 md:py-32 bg-[#f5f1e8] border-t border-[#e8ddc3]/60 relative overflow-hidden"
    >
      <div className="pointer-events-none absolute -top-32 right-0 w-[600px] h-[600px] rounded-full bg-gradient-to-bl from-[#e8ddc3]/40 to-transparent blur-3xl" />

      <div className="relative max-w-7xl mx-auto">
        <Reveal className="text-center mb-12 md:mb-16 px-6">
          <div className="text-[11px] md:text-xs tracking-[0.25em] uppercase text-[#b59557] mb-4">
            Opiniones
          </div>
          <h2 className="font-serif font-medium text-[#1a1816] text-3xl md:text-5xl leading-tight">
            Lo que dicen{" "}
            <span className="italic text-[#b59557] font-light">nuestros clientes</span>
          </h2>
          <div className="mt-6 inline-flex items-center gap-3 px-5 py-2 rounded-full bg-white border border-[#e8ddc3]">
            <div className="flex items-center gap-0.5">
              {[0, 1, 2, 3, 4].map((i) => (
                <Star key={i} className="h-4 w-4 fill-[#d4b97a] text-[#d4b97a]" />
              ))}
            </div>
            <span className="text-sm text-[#3a3228]">
              <span className="font-semibold">4.9</span>
              <span className="text-[#8a7340]"> · +500 retratos entregados</span>
            </span>
          </div>
        </Reveal>

        {/* Row 1 - scrolls left */}
        <Reveal>
          <div className="marquee-row group" aria-hidden={false}>
            <div className="marquee-track marquee-left">
              {[...row1, ...row1].map((t, idx) => (
                <TestimonialCard key={`r1-${idx}`} t={t} />
              ))}
            </div>
          </div>
        </Reveal>

        {/* Row 2 - scrolls right */}
        <Reveal delay={1}>
          <div className="marquee-row group mt-6">
            <div className="marquee-track marquee-right">
              {[...row2, ...row2].map((t, idx) => (
                <TestimonialCard key={`r2-${idx}`} t={t} />
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
